import { rangeRight } from 'lodash'
import { Event } from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    count: 0,
    item: null,
    //
    itemsPerPage: 10,
    pageText: '',
    loading: false,
    //
    searchParams: {}
  },
  actions: {
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.searchParams) {
        const searchParams = {
          ...state.searchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }
        const [count, items] = await Promise.all([Event.count(searchParams), Event.search(searchParams)])

        if (count > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            items,
            count,
            itemsPerPage,
            searchParams
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > count || pageStop === -1 ? count : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${count}`
          commit('changeState', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (count > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    async search({ commit, state, dispatch }, query) {
      const searchParams = {
        _limit: state.itemsPerPage,
        ...query,
        _sort: 'createdAt:DESC'
      }

      commit('changeState', { searchParams })
      dispatch('requestPageSettings', {})
    },
    async fetchOne({ commit }, id) {
      const data = await Event.fetchOne(id)
      commit('changeState', { item: data })
    },
    async create({ dispatch }, params) {
      await Event.create(params)
      dispatch('requestPageSettings', {})
    },
    async update({ dispatch }, { id, ...params }) {
      await Event.update(id, params)
      dispatch('fetchOne', id)
    },
    async delete(_, id) {
      await Event.remove(id)
    }
  },
  mutations: {},
  getters: {
    getItems: state => state.items,
    getItem: state => state.item
  }
}
